module.exports = __webpack_public_path__ + "static/media/cancel_white.ed1a6a14.svg";